import imageCompression from "browser-image-compression";

async function ImageCompress(file) { 
    const imageFile = file;

    const options = {
      maxWidthOrHeight: 720,
      useWebWorker: true
    };
      const compressedFile = await imageCompression(imageFile, options);
      return compressedFile;
     }
export {ImageCompress};